import React from 'react';
import { Link } from 'react-router-dom';

const About = () => {
  return (
    <div>
      <div className="about-area position-relative overflow-hidden" id="about-sec">
        <div className="container">
          <div className="row" style={{ marginTop: "30px" }}>
            <div className="col-xl-6">
              <div className="img-box1">
                <div className="img1"><img src="assets/img/normal/about_1_1.jpg" alt="About" /></div>
                <div className="img2"><img src="assets/img/normal/about_1_2.jpg" alt="About" /></div>
                <div className="img3"><img src="assets/img/normal/about_1_3.jpg" alt="About" /></div>
              </div>
            </div>
            <div className="col-xl-6">
              <div className="ps-xl-4 ms-xxl-4">
                <div className="title-area about1-title-box mb-20 pe-xxl-5 me-xxl-5" style={{ marginTop: "30px" }}>
                  <span className="sub-title style1 text-anime-style-2">About Avighna Energy Solutions</span>
                  <h2 className="sec-title mb-20 heading text-anime-style-3">Solutions That Evolve with Your Business</h2>
                  <p className="sec-text mb-30 wow fadeInUp" data-wow-delay=".1s">
                    IT solutions refer to a broad range of services and technologies designed to address specific business needs,
                    streamline operations, and drive growth. These solutions encompass hardware.
                  </p>
                </div>

                <div className="about-item-wrap">
                  <div className="about-item wow fadeInUp" data-wow-delay=".2s">
                    <div className="about-item_img">
                      <img src="assets/img/icon/map3.svg" alt="" />
                    </div>
                    <div className="about-item_centent">
                      <h5 className="box-title">Manage Tech Services</h5>
                      <p className="about-item_text">There are many variations of passages available but the majority.</p>
                    </div>
                  </div>
                  <div className="about-item wow fadeInUp" data-wow-delay=".3s">
                    <div className="about-item_img">
                      <img src="assets/img/icon/guide.svg" alt="" />
                    </div>
                    <div className="about-item_centent">
                      <h5 className="box-title">Internal Networking</h5>
                      <p className="about-item_text">There are many variations of passages available but the majority.</p>
                    </div>
                  </div>
                </div>

                <div className="mt-35 wow fadeInUp">
                  <Link to="/about" className="th-btn th-icon">
                    Learn More <i className="fa-light fa-arrow-right-long"></i>
                  </Link>
                </div>
              </div>
            </div>
          </div>

          <div className="shape-mockup shape1 d-none d-xl-block" data-top="12%" data-right="-16%">
            <img src="assets/img/shape/ab-1-shape-1.png" alt="shape" />
          </div>
          <div className="shape-mockup shape3 d-none d-xl-block" data-bottom="2%" data-left="-20%">
            <img src="assets/img/shape/ab-1-shape-2.png" alt="shape" />
          </div>
          <div className="shape-mockup about-shape movingX d-none d-xxl-block" data-bottom="20%" data-right="-11%">
            <img src="assets/img/normal/about-right-img.jpg" alt="shape" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
